import { IBillboardWithImageProps } from '../../shared/components/v2/BillboardWithImage/BillboardWithImage'
import { ModuleBackgroundColors, ModulePadding } from '../../shared/components/v2/ModuleSection/ModuleSection'
import { TEXT_FONT_COLOR, TEXT_FONT_STYLE, TEXT_TAG } from '../../shared/components/v2/Text/TextV2'
import { actionButtonStyle } from '../../shared/components/v2/ActionButton/ActionButton'
import { ITextBlockProps } from '../../shared/components/v2/TextBlock/TextBlock'
import { ComponentType } from '../../shared/components/v2/types/componentType'
import { MobileImageLocation } from '../../shared/components/v2/BillboardWithImage/BillboardImage'

export const aboutHeroBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.goldTint1,
    mobile: ModuleBackgroundColors.goldTint1,
  },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.NONE },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.NONE },
  copyLocation: 'left',
  dataTestId: 'about-hero-billboard-with-image',
  title: {
    tag: TEXT_TAG.h1,
    text: 'About NorthOne',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text:
        'NorthOne is a simple and fast Business Deposit Account. We help builders and makers manage their money by making banking effortless.',
      textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    src: '/static/v2/about-page/about-hero.png',
    mobileSrc: '/static/v2/about-page/about-hero-mobile.png',
    alt: 'Phone, NorthOne Card and notification advising check cleared',
    sx: {
      marginBottom: ['-1px'],
    },
  },
}

export const aboutInsightsBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.L, bottom: ModulePadding.NONE },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.NONE },
  copyLocation: 'right',
  dataTestId: 'about-insights-billboard-with-image',
  title: {
    tag: TEXT_TAG.h1,
    text: '',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text: `Opening a NorthOne Account is easy—it takes a few minutes to open a Deposit Account. Get access to mobile ACH, wires, deposit funds from approved checks<sup>1</sup>, and withdraw cash from any MoneyPass ATM nationwide<sup>2</sup>.

        Through our app, you can get insight into your business’ revenue and spending. You have full control and can run your business from anywhere in the world.`,
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    mobileImageLocation: MobileImageLocation.BOTTOM,
    src: '/static/v2/about-page/about-insights.png',
    mobileSrc: '/static/v2/about-page/about-insights-mobile.png',
    alt: 'NorthOne Insight feature for showing revenue and expenses',
  },
}

export const aboutMoveMoneyBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.L, bottom: ModulePadding.L },
  mobileModulePadding: { top: ModulePadding.NONE, bottom: ModulePadding.SM },
  copyLocation: 'left',
  dataTestId: 'about-move money-billboard-with-image',
  title: {
    tag: TEXT_TAG.h1,
    text: '',
    textFontStyle: TEXT_FONT_STYLE.h1,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text: `With the capabilities of a full Deposit Account in the palm of your hands, NorthOne’s banking experience allows you to save time and money. We automate the time-consuming tasks required for you to close your books at the end of each month.`,
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    src: '/static/v2/about-page/about-movemoney.png',
    alt: 'Phone with NorthOne move money options pay deposit transfer scheduled transactions',
    sx: {
      display: ['none', 'none', 'inline'],
    },
  },
}
export const aboutOurHistoryTextBlockProps: ITextBlockProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.goldTint4,
    mobile: ModuleBackgroundColors.goldTint4,
  },
  modulePadding: { top: ModulePadding.L, bottom: ModulePadding.L },
  dataTestId: 'about-our-history-text-block',
  title: {
    text: 'Our History',
    tag: TEXT_TAG.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
    textFontStyle: TEXT_FONT_STYLE.h2,
  },
  body: [
    {
      type: ComponentType.Text,
      props: {
        text: `NorthOne started when we asked ourselves how we could make small business owners more successful. We set out to create a Deposit Account that solves real problems. From day one to today, our mission has been to make the financial system more inclusive and rebalance the economy from the bottom up.`,
        tag: TEXT_TAG.p,
        textFontColor: TEXT_FONT_COLOR.blackPrimary,
        textFontStyle: TEXT_FONT_STYLE.bodyXlargeLight,
        sx: {
          padding: ['0 20px', '0 20px', '0 80px'],
          marginBottom: '50px',
        },
      },
    },

    {
      type: ComponentType.TextBlockList,
      props: {
        itemSx: {
          width: ['100%', '100%', '60%'],
        },
        list: [
          {
            iconSrc: '/static/v2/about-page/about-idea-icon.svg',
            iconColor: TEXT_FONT_COLOR.blackPrimary,
            iconAlt: 'blue lightbulb icon',
            title: {
              text: 'An Idea',
              tag: TEXT_TAG.h3,
              textFontStyle: TEXT_FONT_STYLE.h3Serif,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                "NorthOne was founded in 2017 by Eytan Bensoussan and Justin Adler. There was a whiteboard. Dozens of post-it notes. Late nights. Gallons of coffee. And the hope that we could create a banking experience worthy of today's business builders.",
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: {
                marginBottom: '24px',
              },
            },
          },
          {
            iconSrc: '/static/v2/about-page/about-chat-icon.svg',
            iconColor: TEXT_FONT_COLOR.blackPrimary,
            iconAlt: 'blue chat icon',
            title: {
              text: 'Collectively Made',
              tag: TEXT_TAG.h3,
              textFontStyle: TEXT_FONT_STYLE.h3Serif,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                'We interviewed thousands of small business owners from across America in our first year alone. When we heard from them that traditional banks never listen, we listened harder. All of our conversations in coffee shops, diners, and workshops helped us craft a banking app that worked for business owners.',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: {
                marginBottom: '24px',
              },
            },
          },
          {
            iconSrc: '/static/v2/about-page/about-history-icon.svg',
            iconColor: TEXT_FONT_COLOR.blackPrimary,
            iconAlt: 'blue script text that says lets get to work',
            title: {
              text: 'Connecting the Dots',
              tag: TEXT_TAG.h3,
              textFontStyle: TEXT_FONT_STYLE.h3Serif,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                'Our dedicated team worked long into the night for months on end. We found a small army of like-minded partners, experts, and advisors, and we all worked tirelessly to bring NorthOne to life. The whole time repeating the words that still welcome new customers to NorthOne: Let’s get to work.\n',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: {
                marginBottom: '24px',
              },
            },
          },
          {
            iconSrc: '/static/v2/about-page/about-launch-icon.svg',
            iconColor: TEXT_FONT_COLOR.blackPrimary,
            iconAlt: 'blue launching rocket icon',
            title: {
              text: 'NorthOne Today',
              tag: TEXT_TAG.h3,
              textFontStyle: TEXT_FONT_STYLE.h3Serif,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
            },
            body: {
              tag: TEXT_TAG.p,
              text:
                'NorthOne launched to the public in August 2019. Our story, like this timeline, is still being written each day. But one thing stays true: we work hard, fast, and smart.',
              textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
              textFontColor: TEXT_FONT_COLOR.blackPrimary,
              sx: {
                marginBottom: '24px',
              },
            },
          },
        ],
      },
    },
  ],
}

export const aboutMissionBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.goldTint3,
    mobile: ModuleBackgroundColors.goldTint3,
  },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.MD },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.MD },
  copyLocation: 'right',
  dataTestId: 'about-mission-billboard-with-image',
  title: {
    tag: TEXT_TAG.h2,
    text: 'Our mission',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text: `Our mission is to eliminate financial administration for business owners like you so you’re able to focus on what really matters: growing a successful business.`,
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },

    {
      tag: TEXT_TAG.p,
      text: `Our banking app is simple to use and accessible on your mobile device because we believe banking should work for you. We take pride in being radically transparent—by providing clear and honest communication, you’ll never be surprised or confused by unknown fees or complicated language.`,
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],
  billboardImage: {
    src: '/static/v2/about-page/about-mission.png',
    mobileSrc: '/static/v2/about-page/about-mission-mobile.png',
    alt: 'Globe',
    sx: {
      position: ['relative', 'relative', 'static'],
      top: ['-130px', '-130px'],
      marginBottom: ['-110px', '-110px', 'auto'],
    },
  },
}

export const aboutOurTeamBillboardProps: IBillboardWithImageProps = {
  moduleBackgroundColor: {
    desktop: ModuleBackgroundColors.white,
    mobile: ModuleBackgroundColors.white,
  },
  modulePadding: { top: ModulePadding.MD, bottom: ModulePadding.NONE },
  mobileModulePadding: { top: ModulePadding.L, bottom: ModulePadding.NONE },
  copyLocation: 'left',
  dataTestId: 'about-our-team-billboard-with-image',
  title: {
    tag: TEXT_TAG.h2,
    text: 'Our team',
    textFontStyle: TEXT_FONT_STYLE.h2,
    textFontColor: TEXT_FONT_COLOR.blackPrimary,
  },
  body: [
    {
      tag: TEXT_TAG.p,
      text: `Our goal is to change the way that small businesses and freelancers think around banking and finance. At NorthOne, we’re proud to have a team with diverse work experiences, including owning and being a part of small businesses. From banking, retail, technology, and more, our team reflects the diversity of our clients, which allow us to provide the best mobile banking experience used by all types of businesses across America.`,
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },

    {
      tag: TEXT_TAG.p,
      text:
        'Our team builds technology that makes financial management accessible and affordable. We believe that better banking products can make the whole financial system more inclusive. Do you believe in this too? We want to hear from you.',
      textFontStyle: TEXT_FONT_STYLE.bodyLargeLight,
      textFontColor: TEXT_FONT_COLOR.blackPrimary,
    },
  ],

  actionButton: {
    body: {
      text: 'Join our team',
      tag: TEXT_TAG.p,
      textFontStyle: TEXT_FONT_STYLE.bodyMediumBold,
      textFontColor: TEXT_FONT_COLOR.white,
    },
    link: '/about/team',
    buttonStyle: actionButtonStyle.copperPrimary,
  },
  billboardImage: {
    mobileImageLocation: MobileImageLocation.TOP,
    src: '/static/v2/about-page/about-team.png',
    mobileSrc: '/static/v2/about-page/about-team-mobile.png',
    alt: 'Team polaroids',
  },
}
